import * as i18n from '@/i18n';

import type { TranslationService } from './types';

const translate = (key: AnyFixMe, arg: AnyFixMe) => i18n.t(key, arg);

translate.addLangs = i18n.addResources;

export default translate as TranslationService;
